/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Student } from './Student';
import {
    StudentFromJSON,
    StudentFromJSONTyped,
    StudentToJSON,
} from './Student';

/**
 * 
 * @export
 * @interface ClassRosterResponse
 */
export interface ClassRosterResponse {
    /**
     * 
     * @type {string}
     * @memberof ClassRosterResponse
     */
    classId: string;
    /**
     * 
     * @type {Array<Student>}
     * @memberof ClassRosterResponse
     */
    users: Array<Student>;
}

/**
 * Check if a given object implements the ClassRosterResponse interface.
 */
export function instanceOfClassRosterResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;
    isInstance = isInstance && "users" in value;

    return isInstance;
}

export function ClassRosterResponseFromJSON(json: any): ClassRosterResponse {
    return ClassRosterResponseFromJSONTyped(json, false);
}

export function ClassRosterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassRosterResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
        'users': ((json['users'] as Array<any>).map(StudentFromJSON)),
    };
}

export function ClassRosterResponseToJSON(value?: ClassRosterResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
        'users': ((value.users as Array<any>).map(StudentToJSON)),
    };
}

